import { render } from "./submitOrder.vue?vue&type=template&id=cbe9ea28&scoped=true"
import script from "./submitOrder.vue?vue&type=script&lang=js"
export * from "./submitOrder.vue?vue&type=script&lang=js"

import "./submitOrder.vue?vue&type=style&index=0&id=cbe9ea28&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbe9ea28"],['__file',"src/views/submitOrder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cbe9ea28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cbe9ea28', __exports__)) {
    console.log('reload')
    api.reload('cbe9ea28', __exports__)
  }
  
  module.hot.accept("./submitOrder.vue?vue&type=template&id=cbe9ea28&scoped=true", () => {
    console.log('re-render')
    api.rerender('cbe9ea28', render)
  })

}


export default __exports__